import { motion } from 'framer-motion'
import GlassCard from '../ui/GlassCard'

interface VideoSectionProps {
  title: string
  description: string
  videoId: string
  delay?: number
}

const VideoSection = ({ title, description, videoId, delay = 0 }: VideoSectionProps) => {
  return (
    <GlassCard className="p-8" delay={delay}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: delay + 0.2 }}
      >
        <h3 className="text-2xl font-light text-gray-800 mb-4">{title}</h3>
        
        <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-6">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
            title={title}
            className="w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        
        <p className="text-gray-700 leading-relaxed">{description}</p>
      </motion.div>
    </GlassCard>
  )
}

export default VideoSection 